import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Header from "../../component/organisms/header";
import MainLayout from "../../component/atoms/layout/mainLayout";
import Sidebar from "../../component/organisms/sidebar";
import TableLayout from "../../component/atoms/layout/table/tableLayout";
import TableTitle from "../../component/atoms/text/table/tableTitle";
import TableTop from "../../component/atoms/layout/table/tableTop";
import TableSearchBtn from "../../component/atoms/layout/table/tableSearchBtn";
import TableCount from "../../component/molecules/tableCount";
import SearchBar from "../../component/atoms/input/searchBar";
import Table from "../../component/atoms/layout/table/table";
import Tr from "../../component/atoms/layout/table/tr";
import Checkbox from "../../component/atoms/input/checkbox";
import Th from "../../component/atoms/layout/table/th";
import Td from "../../component/atoms/layout/table/td";
import Pagenation from "../../component/molecules/pagenation";
import { toast } from "react-toastify";
import { toastMsg } from "../../util/toastMsg";
import moment from "moment";
import Modal from "../../component/templates/Modal";
import { errorHandler } from "../../util/error-handler";
import { route } from "../../router/route";
import TableFilterManager from "../../component/atoms/layout/table/tableFilterManager";
import ThText from "../../component/atoms/text/table/thText";
import TdText from "../../component/atoms/text/table/tdText";
import DelBtn from "../../component/atoms/button/delBtn";
import DetailBtn from "../../component/atoms/button/detailBtn";
import PretendardText from "../../component/atoms/text/pretendardText";
import { modalMsg } from "../../util/modalMsg";
import ManagerApi from "../../api/managerApi";

function Manager(props) {
  const { page } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [filterOpen, setFilterOpen] = useState(-1);
  const [activeId, setActiveId] = useState(null);
  const [activeModalOpen, setActiveModalOpen] = useState(false);
  const [deactiveModalOpen, setDeactiveModalOpen] = useState(false);

  const [delIdList, setDelIdList] = useState([]);
  const [adminDelModalOpen, setAdminDelModalOpen] = useState(false);

  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [approveId, setApproveId] = useState(0);

  const [list, setList] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈

    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getList();
  }, [location]);

  const getList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: page - 1,
        size: pagination.size,
      };
      let list = (await ManagerApi.Get(data)).data.data;
      setList(
        list.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: list.totalElements,
        totalPages: list.totalPages,
        first: list.first,
        last: list.last,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const activeFunc = async (activation) => {
    try {
      const data = {
        activation,
      };
      await ManagerApi.Activation(activeId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setActiveModalOpen(false);
      setDeactiveModalOpen(false);
      getList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteFunc = async () => {
    try {
      const idList = delIdList.map((item) => {
        return item.id;
      });

      const formData = new FormData();
      idList.map((item) => formData.append("idList", item));

      await ManagerApi.DeleteChecked(formData);

      toast(toastMsg.delete);
      setAdminDelModalOpen(false);
      setDelIdList([]);
      getList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const approveFunc = async () => {
    await ManagerApi.Approve(approveId);
    toast("계정이 승인되었습니다.");
    setApproveId(0);
    setApproveModalOpen(false);
    getList();
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>관리자 권한 관리</TableTitle>
          <TableTop>
            <TableCount text={"관리자 (미승인 포함)"} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(`${route.manager}/1?keyword=${keyword}`);
                  }
                }}
                onClick={() => {
                  navigate(`${route.manager}/1?keyword=${keyword}`);
                }}
              />
              <DelBtn
                text={"선택항목 삭제"}
                onClick={() => {
                  const delIdList = list.filter((item) => item.checked);
                  if (delIdList.length <= 0) {
                    toast("항목을 선택해주세요");
                    return;
                  }
                  if (delIdList.filter((item) => item.managerAuthority === "ROOT").length > 0) {
                    toast("ROOT 관리자는 삭제할 수 없습니다");
                    return;
                  }
                  setDelIdList([...delIdList]);
                  setAdminDelModalOpen(true);
                }}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              <col width="140px" />
              <col width="196px" />
              <col width="148px" />
              <col width="89px" />
              <col width="147px" />
              <col width="135px" />
              <col width="161px" />
              <col width="77px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={list.filter((item) => item.checked).length === list.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setList(
                          list.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setList(
                          list.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <ThText>이메일</ThText>
                </Th>
                <Th>
                  <ThText>이름</ThText>
                </Th>
                <Th>
                  <ThText>관리자 유형</ThText>
                </Th>
                <Th>
                  <ThText>신청일/승인일</ThText>
                </Th>
                <Th>
                  <ThText>활성화</ThText>
                </Th>
                <Th>
                  <ThText style={{ textAlign: "center", paddingRight: "41px" }}>승인상태</ThText>
                </Th>
                <Th>
                  <ThText style={{ textAlign: "center", paddingRight: "20px" }}>상세보기</ThText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {list.map((item, index) => {
                return (
                  <Tr style={{ height: "57px", background: "#fff" }} key={index}>
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setList([...list]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TdText
                        style={{
                          width: "170px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          wordBreak: "break-all",
                        }}
                      >
                        {item.email}
                      </TdText>
                    </Td>
                    <Td>
                      <TdText>{item.name}</TdText>
                    </Td>
                    <Td>
                      <TdText>{item.managerAuthorityTitle}</TdText>
                    </Td>
                    <Td>
                      <TdText>{moment(item.createdAt).format("YYYY/MM/DD")}</TdText>
                    </Td>
                    <Td>
                      <TableFilterManager
                        onClick={() => {
                          filterOpen === index ? setFilterOpen(-1) : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.isActive}
                        notApprovedText={"비활성"}
                        list={[
                          {
                            value: true,
                            title: "활성",
                            onClick: () => {
                              setActiveId(item.id);
                              setActiveModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "비활성",
                            onClick: () => {
                              setActiveId(item.id);
                              setDeactiveModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          paddingRight: "41px",
                        }}
                      >
                        <TdText
                          style={{
                            color: `${item.isApproved ? "#262c31" : "#FF003D"}`,
                            fontWeight: "600",
                          }}
                        >
                          {item.isApproved ? "승인" : "미승인"}
                        </TdText>
                        {item.isApproved ? null : (
                          <PretendardText
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              color: "#EF594B",
                              border: "1px solid #EF594B",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "3px 8px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setApproveId(item.id);
                              setApproveModalOpen(true);
                            }}
                          >
                            승인하기
                          </PretendardText>
                        )}
                      </div>
                    </Td>
                    <Td>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingRight: "20px",
                        }}
                      >
                        <DetailBtn
                          onClick={() => {
                            navigate(route.manager_detail + `/${item.id}`);
                          }}
                        />
                      </div>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagenation
            route={route.manager}
            queryString={`keyword=${keyword}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </TableLayout>
        {adminDelModalOpen ? (
          <Modal
            title={modalMsg.delete?.title}
            text={modalMsg.delete?.content}
            setModalOpen={setAdminDelModalOpen}
            onClick={() => {
              deleteFunc();
            }}
          />
        ) : (
          ""
        )}
        {deactiveModalOpen ? (
          <Modal
            title={modalMsg.deactivate?.title}
            setModalOpen={setDeactiveModalOpen}
            onClick={() => {
              activeFunc(false);
            }}
          />
        ) : (
          ""
        )}
        {activeModalOpen ? (
          <Modal
            title={modalMsg.activate?.title}
            setModalOpen={setActiveModalOpen}
            onClick={() => {
              activeFunc(true);
            }}
          />
        ) : (
          ""
        )}
        {approveModalOpen ? (
          <Modal
            title={"승인하시겠습니까?"}
            setModalOpen={setApproveModalOpen}
            onClick={() => {
              approveFunc();
            }}
          />
        ) : (
          ""
        )}
      </MainLayout>
    </>
  );
}

export default Manager;
